import React from 'react';

import { TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './PaymentResultInbodyBlock.module.scss';
import InbodyScaleImg from '../../../shared/assets/image/inbody-scale.png';
import { useInbodyPin } from './hooks/useInbodyPin';

type InbodyBlockProps = {
  entityId: number;
  title?: string;
};

const PaymentResultsInbodyBlock = ({ entityId, title }: InbodyBlockProps) => {
  const { inbodyPin, isLoading } = useInbodyPin({ entityId });

  if (isLoading) {
    return null;
  }

  const inbodyDescription = inbodyPin
    ? `Use the PIN code to unlock the InBody machine and begin your measurement session`
    : 'Begin by stepping on the machine and follow the on-screen instructions';

  return (
    <div className={classes.contentBlock}>
      <TitleWithDescription title={title} description={inbodyDescription} />
      {inbodyPin ? (
        <div className={classes.inbodyPin}>{inbodyPin}</div>
      ) : (
        <img src={InbodyScaleImg} alt="InBody Scale" />
      )}
    </div>
  );
};

export { PaymentResultsInbodyBlock };
